/**
 * @module AVAnalyticsFlowNames
 * These values are used to identify the flow of analytics events
 * The values defined by ASC, see https://docs.google.com/spreadsheets/d/1AXdwZ9eAxhhGvhtij5MQlC-3CSXxR8vQ0ri9X3ACD4U/edit?pli=1&gid=1925342755#gid=1925342755
 */
export default {
  ECOMMERCE: 'ecommerce',
  CREDIT: 'credit_app',
  TRADE: 'trade',
  FINANCE: 'financing',
  TEST_DRIVE: 'test_drive',
  COMPARE: 'compare',
};
